<!-- eslint-disable -->
<ng-container *ngIf="!isMobile; else mobileView">
  <div class="cs-deposit" *ngIf="paymentsAllowed" [ngClass]="checkCurrentDepositAndLicense()">
    <div class="cs-deposit--payments border-color-dark">
      <div class="cs-deposit--section-payments background-color-light">
        <cs-transaction-item *ngFor="let type of paymentOptions" [payment]="type" [paymentSelected]="paymentSelected"
          (navigate)="selectOption($event)" class="cs-trans px-1 py-2">
        </cs-transaction-item>
      </div>
    </div>

    <div class="cs-deposit--content">
      <div class="cs-deposit--content-container" #content>
        <!-- STEP 1 -->
        <div [class]="classDepSecColorLightP4">
          <i class="cs-empty-icon codere-icon icon-insert-coin color-dark p-bottom-2"></i>
          <h4 class="text-center color-dark">{{'cashierdeposittxt' | translate}}</h4>
          <h4 *ngIf="globalVars?.licenseType === LicenseTypes.ArgentinaCaba" class="text-center color-dark">
            {{'cashierdeposittxt02' | translate}}
          </h4>
        </div>

        <!-- STEP 2 -->
        <div *ngIf="paymentSelected" class="cs-deposit--section text-center"
          [ngClass]="currentPayment === 'transferencia bancaria' ? 'background-light-section': ''">
          <!-- <div class="cs-deposit--container background-color-dark w-100 p-2" *ngIf="!bankAccountMethodBehaviour && !localCodereMethodBehaviour && !tpagaDepositBehaviour"> -->
          <div [class]="classContainerBehaviourP2" *ngIf="isDepositCards()">
            <div class="text-left cs-card-mx-advice" *ngIf="isMexVisaMastercard()">
              <p>
                {{'Payments_depositsCardMatchTxt' | translate}}
              </p>
            </div>
            <div [class]="classDepImgPy1">
              <img [src]="getPaymentSelectedImage()" alt="" />
            </div>

            <cs-calculator [options]="calculatorConfig" [paymentSelected]="paymentSelected"
              [amount]="paymentForm?.get('amount')?.value" [isActiveKeyboard]="isActiveKeyboard"
              (amountSelected)="amountSelected($event)" (blockOperation)="handleCalculatorOperationBlocked($event)"
              (setCustomAmount)="setCustomAmount($event)" (inputAmount)="inputAmount($event)"
              [blockCalculator]="blockCalculator">
            </cs-calculator>

            <!-- Paypal -->
            <ng-template [ngIf]="!hidePaypalButton && isPaypalMethod">
              <button [disabled]="isDisabled()" [class]="classActionButtonColorSecondary" tappable
                (click)="goToPaypalDeposit()">
                <span [class]="classActionButtonColorLight"> {{ 'uPCDep' | translate }} </span>
              </button>
            </ng-template>

            <!-- LOTBA CODE INPUT-->
            <form class="cs-lotba-form p-1 w-100" isLotbaCABA *ngIf="isLotbaCABA()">
              <div class="cs-lotba-form--field background-color-white m-bottom-1">
                <input class="w-100 p-left-1" type="text" placeholder="{{'Payments_depositsTypeCodeTxt'| translate }}"
                  [formControl]="lotbaCodeNumber" />
              </div>
            </form>
            <!-- END LOTBA CODE INPUT-->

            <ng-container *ngIf="isOxxoBankForm() else withoutForm">
              <cs-oxxobank-form [paymentForm]="paymentForm" [license]="globalVars?.licenseType"
                (checkDeposit)="checkDeposit()">
              </cs-oxxobank-form>

              <ng-template [ngIf]="isOxxoDeposit()">
                <button [disabled]="isDisabled()" [class]="classActionButtonColorSecondary" tappable
                  (click)="checkOxxoDeposit()">
                  <span [class]="classActionButtonColorLight"> {{ 'uPCDep' | translate }} </span>
                </button>
              </ng-template>
            </ng-container>
          </div>

          <!-- Bank Account -->
          <div [class]="classBankAccountP2Heigth" *ngIf="bankAccountMethodBehaviour">
            <div [class]="classDepImgPy1">
              <img [src]="getPaymentSelectedImage()" alt="" />
            </div>
            <cs-transfer-deposit [transferConfig]="transferConfig"></cs-transfer-deposit>
          </div>
          <div [class]="classBankAccountP2Heigth" *ngIf="BankcvuMethodBehaviour">
            <div [class]="classDepImgPy1">
              <img [src]="getPaymentSelectedImage()" alt="" />
            </div>
          </div>

          <!-- Local Codere -->
          <div [class]="classContainerBehaviourP1" *ngIf="localCodereMethodBehaviour">
            <div class="cs-deposit--img cs-deposit--img-small py-1">
              <img [src]="getPaymentSelectedImage()" alt="" />
            </div>
            <cs-local-codere [license]="globalVars?.licenseType" [localConfig]="localConfig"
              (openCodereLocals)="openCodereLocals()">
            </cs-local-codere>
          </div>

          <!-- Punto Pago -->
          <div [class]="classContainerBehaviourP1" *ngIf="puntoPagoBehaviour">
            <div class="cs-deposit--img cs-deposit--img-small py-1">
              <img [src]="getPaymentSelectedImage()" alt="" />
            </div>
            <cs-punto-pago></cs-punto-pago>
          </div>

          <!--Crown casino-->
          <div [class]="classContainerBehaviourP1" *ngIf="CrownCasinoBehaviour">
            <div class="cs-deposit--img cs-deposit--img-small py-1">
              <img [src]="getPaymentSelectedImage()" alt="" />
            </div>
            <cs-crown-casino></cs-crown-casino>
          </div>

          <div [class]="classContainerBehaviourP2" *ngIf="trueLayerBehaviour">
            <div [class]="classDepImgPy1">
              <img [src]="getPaymentSelectedImage()" alt="" />
            </div>
            <cs-truelayer [paymentSelected]="paymentSelected" [config]="calculatorConfig"
              (checkDeposit)="checkDeposit(true)" [paymentBehaviour]="trueLayerBehaviour" class="w-100">
            </cs-truelayer>
          </div>
        </div>

        <ng-template #withoutForm>
          <div class="deposit-consent-container">
            <span *ngIf="displayDepositDeclaration" class="deposit-consent"> {{ depositDeclaration }} </span>
            <!-- todo: revisar [disabled]="checkLotbaDepositisActiveKeyboard" -->
            <ng-template [ngIf]="showDepositarButton">
              <button [class]="classActionButtonColorSecondary" tappable [disabled]="isOperationBlocked"
                (click)="checkDeposit()">
                <span [class]="classActionButtonColorLight"> {{ 'uPCDep' | translate }} </span>
              </button>
            </ng-template>
          </div>
        </ng-template>

        <!-- STEP 3 -->
        <div *ngIf="step === SectionStep.third" [class]="classDepSecColorLight">
          <cs-payment-iframe class="cs-deposit--section-iframe" *ngIf="iFramePaymentMethodBehaviourResult"
            [options]="iFramePaymentMethodBehaviourResult?.iframeArgs" [payment]="paymentSelected"
            [depositAmount]="paymentForm?.controls['amount']?.value" (requestInfo)="requestIframe($event)">
          </cs-payment-iframe>

          <cs-payvalida-ok *ngIf="isPayValida()"
            [payValidaCashPaymentMethodBehaviour]="selectPayValidaCashPaymentMethod"
            [payvalidaResult]="payValidaCashMethodBehaviourResult">
          </cs-payvalida-ok>

          <cs-qr-code *ngIf="qrDepositBehaviour" [depositBehaviour]="qrDepositBehaviour"
            [depositResult]="qrMethodBehaviourResult">
          </cs-qr-code>

          <div *ngIf="paypalPaymentMethodBehaviour" class="paypalstep">
            <div [class]="classDepImgPy1">
              <img [src]="getPaymentSelectedImage()" alt="" />
            </div>
            <h4>{{ getDepositConfirmationStepText() }}</h4>
            <h4>{{ 'Payments_depositsGoToPayPalTxt' | translate }}</h4>
            <div class="cs-action-button">
              <div id="paypal-button"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="cs-deposit no-payment-allowed" *ngIf="!paymentsAllowed">
    <div class="container-not-paymet">
      <div class="content-not-payment geo-error">
        {{paragraphNoPayment}}
        <a href="apuestas@codere.com" class="color-accent">{{'Payments_depositsApuestasCodereTxt' | translate }}</a>
        o
        <div>
          <img style="width: 20px; height: 20px" src="assets/global/img/whats.png" alt="Codere whatsapp" class="" />
          {{'Payments_depositsWhatsAppCodereTxt' | translate }}
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #mobileView>
  <div class="cs-deposit" #content *ngIf="paymentsAllowed">
    <!-- STEP 1 -->
    <div [class]="classDepSecColorLight">
      <cs-transaction-item *ngFor="let type of paymentOptions" [payment]="type" (navigate)="selectOption($event)">
      </cs-transaction-item>
    </div>

    <!-- STEP 2 -->
    <div *ngIf="paymentSelected" class="cs-deposit--section text-center">
      <!--Crown casino-->
      <div [class]="classContainerBehaviourP1" *ngIf="CrownCasinoBehaviour">
        <cs-crown-casino></cs-crown-casino>
      </div>
      <div [class]="classContainerBehaviourP2" *ngIf="isDepositCards()">
        <div class="text-left cs-card-mx-advice" *ngIf="isMexVisaMastercard()">
          <p>
            {{'Payments_depositsCardMatchTxt' | translate }}
          </p>
        </div>

        <div *ngIf="!CrownCasinoBehaviour">
          <cs-calculator [options]="calculatorConfig" [paymentSelected]="paymentSelected"
            [amount]="paymentForm?.get('amount')?.value" [isActiveKeyboard]="isActiveKeyboard"
            (amountSelected)="amountSelected($event)" (blockOperation)="handleCalculatorOperationBlocked($event)"
            (setCustomAmount)="setCustomAmount($event)" (setInputKeyboard)="setInputKeyboard()"
            [blockCalculator]="blockCalculator">
          </cs-calculator>
        </div>
        <!-- Paypal -->
        <ng-template [ngIf]="!hidePaypalButton && isPaypalMethod">
          <button [disabled]="isDisabled()" [class]="classActionButtonColorSecondary" tappable
            (click)="goToPaypalDeposit()">
            <span [class]="classActionButtonColorLight"> {{ 'uPCDep' | translate }} </span>
          </button>
        </ng-template>
        <!-- LOTBA CODE INPUT-->
        <form class="cs-lotba-form p-1 w-100" *ngIf="isLotbaCABA()">
          <div class="cs-lotba-form--field background-color-white m-bottom-1">
            <input class="w-100 p-left-1" type="text" [formControl]="lotbaCodeNumber" />
          </div>
        </form>
        <!-- END LOTBA CODE INPUT-->

        <ng-container *ngIf="isOxxoBankForm() else withoutForm">
          <cs-oxxobank-form [paymentForm]="paymentForm" [license]="globalVars?.licenseType"
            (checkDeposit)="checkDeposit()">
          </cs-oxxobank-form>

          <!-- Deposit Button -->
          <ng-template [ngIf]="isOxxoDeposit()">
            <button [disabled]="isDisabled()" [class]="classActionButtonColorSecondary" tappable
              (click)="checkOxxoDeposit()">
              <span [class]="classActionButtonColorLight"> {{ 'uPCDep' | translate }} </span>
            </button>
          </ng-template>
        </ng-container>

        <!-- PayPal Button -->
        <!-- <div [hidden]="!paypalPaymentMethodBehaviour" class="cs-action-button">
          <div id="paypal-button"></div>
        </div> -->
      </div>

      <!-- BankTransfer -->
      <div [class]="classContainerBehaviourP2" *ngIf="bankAccountMethodBehaviour">
        <cs-transfer-deposit [transferConfig]="transferConfig"> </cs-transfer-deposit>
      </div>

      <!-- Local Codere -->
      <div [class]="classContainerBehaviourP1" *ngIf="localCodereMethodBehaviour">
        <cs-local-codere [license]="globalVars?.licenseType" [localConfig]="localConfig"
          (openCodereLocals)="openCodereLocals()"></cs-local-codere>
      </div>

      <!-- Punto Pago -->
      <div [class]="classContainerBehaviourP1" *ngIf="puntoPagoBehaviour">
        <cs-punto-pago></cs-punto-pago>
      </div>

      <!-- TrueLayer -->
      <div [class]="classContainerBehaviourP1TrueLayer" *ngIf="trueLayerBehaviour">
        <cs-truelayer #truelayer (closeKeyBoardTL)="closeKeyBoard('0')" [paymentSelected]="paymentSelected"
          [paymentBehaviour]="trueLayerBehaviour" (setInputKeyboardtl)="setInputKeyboardtl($event)"
          [config]="calculatorConfig" (checkDeposit)="checkDeposit(true)" [stateDepositButton]="stateDepositButton"
          class="w-100">
        </cs-truelayer>
      </div>
    </div>

    <ng-template #withoutForm>
      <div class="deposit-consent-container">
        <span *ngIf="displayDepositDeclaration" class="deposit-consent"> {{ depositDeclaration }} </span>
        <ng-template [ngIf]="showDepositarButton">
          <button [disabled]="isActiveKeyboard || isOperationBlocked"
            [ngClass]="{'cs-calculator--disabled-form': isActiveKeyboard || isOperationBlocked}"
            [class]="classActionButtonColorSecondary" tappable (click)="checkDeposit()">
            <span [class]="classActionButtonColorLight"> {{ 'uPCDep' | translate }} </span>
          </button>
        </ng-template>
      </div>
    </ng-template>

    <!-- STEP 3 -->
    <div *ngIf="step === SectionStep.third" [class]="classDepSecColorLight">
      <cs-payment-iframe class="cs-deposit--section-iframe" *ngIf="iFramePaymentMethodBehaviourResult"
        [options]="iFramePaymentMethodBehaviourResult?.iframeArgs" [payment]="paymentSelected"
        [depositAmount]="paymentForm?.controls['amount']?.value" (requestInfo)="requestIframe($event)">
      </cs-payment-iframe>

      <cs-payvalida-ok *ngIf="isPayValida()" [payValidaCashPaymentMethodBehaviour]="selectPayValidaCashPaymentMethod"
        [payvalidaResult]="payValidaCashMethodBehaviourResult">
      </cs-payvalida-ok>

      <div *ngIf="paypalPaymentMethodBehaviour" class="paypalstep">
        <div [class]="classDepImgPy1">
          <img [src]="getPaymentSelectedImage()" alt="" />
        </div>
        <h4>{{ getDepositConfirmationStepText() }}</h4>
        <h4>{{ 'Payments_depositsGoToPayPalTxt' | translate }}</h4>
        <div class="cs-action-button">
          <div id="paypal-button"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="cs-deposit no-payment-allowed" *ngIf="!paymentsAllowed">
    <div class="container-not-paymet">
      <div class="content-not-payment geo-error">
        {{paragraphNoPayment}}
        <a href="apuestas@codere.com" class="color-accent">{{'Payments_depositsApuestasCodereTxt' | translate }}</a>
        o
        <div>
          <img style="width: 20px; height: 20px" src="assets/global/img/whats.png" alt="Codere whatsapp" class="" />
          {{'Payments_depositsWhatsAppCodereTxt' | translate }}
        </div>
      </div>
    </div>
  </div>
  <custom-keyboard *ngIf="isActiveKeyboard && sectionStep === SectionStep.second" [active]="isActiveKeyboard"
    [cashier]="true" (closeKeyBoard)="closeKeyBoard($event)" (press)="pressInputKeyBoard($event)"></custom-keyboard>
</ng-template>